"use client";

import { usePathname } from "next/navigation";
import { createContext, ReactNode, useContext, useState } from "react";
import { findOwnerMenuItem, useMenu } from "./menu-context";

const UnitContext = createContext<{
  currentUnit: string | null;
  setCurrentUnit: (unit: string | null) => void;
}>({
  currentUnit: null,
  setCurrentUnit: () => {},
});

export const UnitProvider = ({
  children,
  initialUnit = null,
}: {
  children: ReactNode;
  initialUnit?: string | null;
}) => {
  const [currentUnit, setCurrentUnit] = useState<string | null>(initialUnit);

  return (
    <UnitContext.Provider value={{ currentUnit, setCurrentUnit }}>
      {children}
    </UnitContext.Provider>
  );
};

export const useUnit = () => useContext(UnitContext);

export const useResolvedUnit = (): string | null => {
  const { currentUnit } = useUnit();
  const headerMenu = useMenu("menu-header");
  const pathname = usePathname();
  if (currentUnit) return currentUnit;
  const owner = findOwnerMenuItem(headerMenu, pathname);
  const slug = owner?.fields?.item?.fields?.slug;
  if (!slug || slug === "index") return null;
  return `unit-${slug}`;
};
